"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buttonGroupAlignment = exports.buttonGroupSpacing = exports.buttonVariant = exports.iconButtonSize = exports.buttonSize = void 0;
exports.buttonSize = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    big: 'big', // deprecated
};
exports.iconButtonSize = {
    default: 'default',
    small2XIconXs: 'small2XIconXs',
    smallXIconS: 'smallXIconS',
    smallIconM: 'smallIconM',
    smallIconS: 'smallIconS',
    smallIconXs: 'smallIconXs',
    mediumIconL: 'mediumIconL',
    mediumIconM: 'mediumIconM',
    mediumIconS: 'mediumIconS',
    largeIconL: 'largeIconL',
    largeIconM: 'largeIconM',
};
exports.buttonVariant = {
    primary: 'primary',
    secondary: 'secondary',
    success: 'success',
    /** @deprecated Use isDestructive property instead */
    destructive: 'destructive',
    tertiary: 'tertiary',
    tertiaryReversed: 'tertiaryReversed',
    text: 'text',
};
exports.buttonGroupSpacing = {
    small: 'small',
    large: 'large',
};
exports.buttonGroupAlignment = {
    left: 'left',
    center: 'center',
    right: 'right',
};
